/**
 * PC_RF_01
 * Importing the component, API and packages
 */
import React, { useEffect, useState } from 'react';
import $ from 'jquery';

import { individualRequest, updateRequest } from '../../service/PerformanceAPI';

import './ProfileRequest.css';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import moment from 'moment';
import { NotificationTrigger } from '../../utils/RegHandling';
import { connect } from 'react-redux'
import { encryptStorage } from '../../constant'
import { getS3 } from '../../utils/Download';

function ProfileRequestfForm(props) {

    /**
     * PC_RF_02
     * State variables are created
     */
    let requestInfo = {
        name: '',
        completedDate: '',
        category: '',
        status: '',
        reportsTo: '',
        domain: '',
        comments: '',
        empId: ''
    };
    const [requesData, setRequestData] = useState([]);
    const [info, setInfo] = useState(requestInfo);
    const [profileId, setProfileId] = useState();
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);
    const [commentsValidation, setCommetsValidation] = useState('');

    /**
     * PC_TF_03,PC_TF_04,PC_TF_05
     * useEffect is invoked then loadRequestData function is called
     * templateid is checked, whether template has to  edit the getTemplateCategoryDetails is called with template id
     */
    useEffect(() => {
        //
        if (props?.Id !== undefined && props?.Id !== null) {
            setProfileId(props?.Id);
        }

        loadRequestData();
    }, [props?.Id]);

    const loadRequestData = async () => {

        let userId = encryptStorage.getItem('employeeId');

        let requesData = {
            profileRequestId: props?.Id,
        };
        let response = await individualRequest(requesData);
        if (response.data.ResponseData.length > 0) {

            setRequestData(response.data.ResponseData);
            info.name = response.data.ResponseData[0].employee_name;
            info.category = response.data.ResponseData[0].category;
            info.status = response.data.ResponseData[0].status;
            info.completedDate = response.data.ResponseData[0].completed_date;
            info.comments = response.data.ResponseData[0].comments;
            info.domain = response.data.ResponseData[0].domain;
            info.id = response.data.ResponseData[0].id;
            info.hrId = userId;
            info.empId = response.data.ResponseData[0].emp_id;
            info.createdat = response.data.ResponseData[0].created_at;
            info.reportsTo = response.data.reportsTo;
            setInfo({ ...info });


            if (info.status === 'approved') {
                $('#statusCard').removeClass('bg-white');
                $('#statusCard').removeClass('pending-card-sty');
                $('#statusCard').addClass('bg-pastel-green');
                setbreadCrumbsData([
                    { title: 'Dashboard', path: '/Overview?tab=activities', isActive: true },
                    { title: 'Profile Update', path: '/profileupdate', isActive: true },
                    { title: 'Completed', path: '', isActive: false },
                ]);
            } else if (info.status === 'denied') {
                $('#statusCard').removeClass('bg-white');
                $('#statusCard').removeClass('pending-card-sty');
                $('#statusCard').addClass('bg-pastel-red red-btn');
                setbreadCrumbsData([
                    { title: 'Dashboard', path: '/Overview?tab=activities', isActive: true },
                    { title: 'Profile Update', path: '/profileupdate', isActive: true },
                    { title: 'Completed', path: '', isActive: false },
                ]);
            } else {
                setbreadCrumbsData([
                    { title: 'Dashboard', path: '/Overview?tab=activities', isActive: true },
                    { title: 'Profile Update', path: '/profileupdate', isActive: true },
                    { title: 'Pending', path: '', isActive: false },
                ]);
            }
        }
    }

    /**
     * PC_RF_13, PC_RF_15,PC_RF_16,PC_RF_17,PC_RF_18,PC_RF_19,PC_RF_20
     * submitClick function is invoked when user click save button
     * update API is called then based on the response user is redirect to request grid page
     */
    const requestSubmitClick = async (status) => {
        //
        if (status == 'denied') {
            if (info.comments == '' || info.comments == null) {
                setCommetsValidation('Comments is required');
                return false
            }
        }
        let dataObj = {
            profileRequestId: info.id,
            status: status,
            comments: info.comments,
            hr_id: info.hrId,
            // hr_id: encryptStorage.getItem('employeeId'),

        };

        await updateRequest(dataObj)
            .then((res) => {
                if (res.data.ResponseData === 'Denied the request' || res.data.ResponseData === 'Successfully updated') {
                    let responseValue = res.data.ResponseData
                    NotificationTrigger({ title: "Profile Update", message: res.data.ResponseData === 'Denied the request' ? 'Your Profile update request has been denied' : 'Your Profile update request has been approved', route: `/profilecontainer?EmpId=${info.empId}&IsTeamMember=true`, to_employee: [info.empId], by: info.hrId }, [info.empId], props?.websocket).then(res => {
                        props?.Back(true, responseValue === 'Successfully updated' ? "success" : 'denied');
                    })
                }
            })
    }

    /**
     * PC_RF_12
     * @param {*} e OnchangeName function is invoked when user change the data
     */

    const onChangeComments = (e) => {
        info.comments = e.target.value;
        setInfo({ ...info });
    };

    const bindData = () => {
        return requesData.map((data) => {
            
            return (
                <div>
                    <div className="row my-3">
                        <div className="col-md-6">
                            <h6 className="semibold-text font-12 ppa-yellow-font">Edited</h6>
                            <ul className="list-unstyled">
                                <li className="mb-2">
                                    <h6 className="regular-text font-12 mb-0 ppa-black-font">
                                        {data?.category}: {data?.field}
                                    </h6>
                                    {data?.new_value?.includes('https://ava') ? <> <a style={{cursor:"pointer",  color: 'blue', textDecoration: 'underline'}} onClick={async () => {

                                        window.open(await getS3(data?.new_value), "_blank");


                                    }} target='_blank'><p className="regular-text font-12 mb-0 ppa-grey-font">{data?.new_value}</p></a></> :
                                        <p className="regular-text font-12 mb-0 ppa-grey-font">{data?.new_value}</p>}
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-6">
                            <h6 className="semibold-text font-12 ppa-yellow-font">Old</h6>
                            <ul className="list-unstyled">
                                <li className="mb-2">
                                    <h6 className="regular-text font-12 mb-0 ppa-black-font">
                                        {data?.category}: {data?.field}
                                    </h6>
                                    {data?.old_value?.includes('https://ava') ? <><a style={{cursor:"pointer"}} onClick={async () => {

window.open(await getS3(data?.old_value), "_blank");


}} target='_blank'><p className="regular-text font-12 mb-0 ppa-grey-font text-decoration-line-through">{data?.old_value}</p></a></> :
                                        <p className="regular-text font-12 mb-0 ppa-grey-font text-decoration-line-through">{data?.old_value}</p>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            <div className='mt-4'>
                <BreadCrumbs data={breadCrumbsData} />
            </div>
            <div className="col-md-12 mb-3 bg-color">
                <div className="tab-content" id="v-pills-tabContent">
                    <div className="tab-pane fade show active" id="pending" role="tabpanel" aria-labelledby="pending-tab">
                        <div className="d-flex mx-2 pt-3 pb-4 px-3 bg-white rounded-3">
                            <a>
                                <img
                                    src="/Images/back-arrow.svg"
                                    alt="back-arrow"
                                    className="me-3 mt-4"
                                    onClick={() => {
                                        props?.Back(true);
                                    }}
                                />
                            </a>
                            <div className="w-100">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <img src="/Images/logo-person-user-person-icon.jpg" alt="Profilepic" className="ppa-canditade-profilepic" />
                                        </div>
                                        <div className="ps-3 align-item-center">
                                            <h1 className="font-13 mb-0 semibold-text ppa-black-font">
                                                {info.name}
                                                <span className=" ppa-grey-font pending-para-clr ps-2">{moment(info.createdat).format('MMM DD, YYYY')}</span>
                                            </h1>
                                            <p className=" font-13 pb-0 pt-1  semibold-text ppa-grey-font my-0">
                                                I’m requesting for {info.category} Information Change
                                            </p>
                                        </div>
                                    </div>
                                    <div id="statusCard" className="px-3 py-3 pending-card-sty border-0">
                                        <div className="d-flex align-items-center">
                                            <div>
                                                {info.status === 'Pending' ? (
                                                    <>
                                                        {' '}
                                                        <h1 className="font-12 mb-0 semibold-text">Awaiting Approval</h1>
                                                        <p className=" font-12 pb-0 pt-1  regular-text my-0">1 Pending Approval</p>{' '}
                                                    </>
                                                ) : (
                                                    <>
                                                        {' '}
                                                        <h1 className="font-12 mb-0 semibold-text">Request {info.status}</h1>
                                                        <p className=" font-12 pb-0 pt-1  regular-text my-0">{moment(info.completedDate).format('MMM DD, YYYY')}</p>
                                                    </>
                                                )}
                                            </div>
                                            <div className="ps-3 align-item-center">
                                                <img src="/Images/logo-person-user-person-icon.jpg" alt="ProfilePic" className="ppa-canditade-profilepic" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row py-5">
                                    <div className="col-md-6">
                                        <div className="card rounded-0">
                                            <div className="card-header ppa-card-backgrd d-flex justify-content-between rounded-0 py-3">
                                                <h6 className="mb-0 ppa-white-font tt-bold font-14 align-self-center">
                                                    {info.category} Change
                                                </h6>
                                                <div className="text-end">
                                                    {info.status === 'Pending' ? (
                                                        <>
                                                            <button
                                                                className="btn primary-button bold-text font-13 me-3"
                                                                type="button"
                                                                onClick={() => {
                                                                    requestSubmitClick('approved');
                                                                }}
                                                            >
                                                                Approve
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn secondary-button bold-text font-13"
                                                                onClick={() => {
                                                                    requestSubmitClick('denied');
                                                                }}
                                                            >
                                                                Deny
                                                            </button>
                                                        </>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="d-flex align-items-center pb-3 ppa-border-bottom-sty">
                                                    <div className="d-block">
                                                        <img src="/Images/logo-person-user-person-icon.jpg" alt="Profilepic" className="ppa-profile-pic" />
                                                    </div>
                                                    <div className="d-block ps-3 align-item-center">
                                                        <h1 className="font-15 mb-0 semibold-text ppa-black-font">{info.name}</h1>
                                                        <p className="ppa-grey-font regular-text font-12 mb-0">{info.domain}</p>
                                                        <p className="ppa-grey-font regular-text font-12 mb-0">
                                                            Report Directly to {info.reportsTo}
                                                        </p>
                                                    </div>
                                                </div>

                                                {bindData()}
                                            </div>
                                            {info.status?.toLowerCase() !== 'approved' ?
                                                <div className="card-footer rounded-0 pending-card-footer">
                                                    <div className="d-flex">
                                                        <div className="d-block pe-3">
                                                            <img
                                                                src="/Images/logo-person-user-person-icon.jpg"
                                                                alt="ProfilePic"
                                                                className="ppa-canditade-profilepic"
                                                            />
                                                        </div>
                                                        <div className="w-100">
                                                            <textarea
                                                                disabled={info.status == 'denied' ? true : false}
                                                                className="form-control ppa-textbox-stl custom-textfield"
                                                                id="exampleFormControlTextarea1"
                                                                placeholder="Enter the comments"
                                                                rows={3}
                                                                maxLength={255}
                                                                onChange={(e) => {
                                                                    onChangeComments(e);
                                                                }}
                                                                value={info.comments}
                                                            />
                                                        </div>
                                                    </div>
                                                    <label className='ms-6 text-danger'>{commentsValidation}</label>
                                                </div> : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="Completed" role="tabpanel" aria-labelledby="Completed-tab" />
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(ProfileRequestfForm)
